module.exports = __webpack_public_path__ + "img/SU.ae06dbbc.jpg";